import { FC } from 'react';

import { getBankAccountDisplayNameWithSpecificLocale } from 'common/bankAccount/utils';
import ErrorCard from 'components/ErrorCard';
import Loader from 'components/Loader';
import { StepProps } from 'components/Stepper/types';
import TrackView from 'features/Analytics/TrackView';
import {
  BankTransferCreationStep,
  useBankTransferContext,
} from 'features/Payments/Pages/Transfers/contexts';
import ErrorLayout from 'layouts/ErrorLayout';

import Success from '../../components/Success';
import useBankTransferData from '../../hooks/useBankTransferData';
import locales from './locales';

interface InternalTransferSuccessProps
  extends StepProps<BankTransferCreationStep> {
  donePath?: string;
}

const InternalTransferSuccess: FC<InternalTransferSuccessProps> = ({
  donePath,
}) => {
  const { bankTransfer } = useBankTransferContext('internalTransferSuccess');

  const { amount, fromBankAccountId, toBankAccountId } = bankTransfer;

  const { data, error, refetch } = useBankTransferData({
    fromBankAccountId,
    toBankAccountId,
  });

  if (error) {
    return (
      <ErrorLayout>
        <ErrorCard retry={refetch} />
      </ErrorLayout>
    );
  }

  if (!data) {
    return <Loader />;
  }

  const { fromBankAccount, toBankAccount } = data;

  const toBankAccountName = getBankAccountDisplayNameWithSpecificLocale({
    bankAccount: toBankAccount,
    locale: locales.yourMainAccount,
  });

  const transferLocales = {
    description: locales.internal.description,
    title: locales.internal.title,
  };

  return (
    <>
      <TrackView pageName="NewInternalTransferSuccess" />
      <Success
        amount={amount}
        donePath={donePath}
        fromBankAccount={fromBankAccount}
        recipient={toBankAccountName}
        transferLocales={transferLocales}
      />
    </>
  );
};

export default InternalTransferSuccess;
